import classes from './Retail.module.scss'
import React, { useEffect } from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, { IQuestion } from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp';
import { Link } from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const Retail = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
            
    const title = t('retail.title')
    const description = t('retail.text', {returnObjects: true})

    const blackBlocks = t('retail.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('retail.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('retail.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('retail.benefitBlocks', {returnObjects: true})

    const stories = t('retail.stories', {returnObjects: true})



    const useCaseText = t('retail.useCaseSubtitle')

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('retail.Faq.left', {returnObjects: true}),
        right: t('retail.Faq.right', {returnObjects: true}),
    };

    return (
        <>
            <Helmet>
                <title>
                    Retail IT Solutions & Omnichannel Management Systems | Goteco
                </title>
                <meta
                    name="description"
                    content="Unify in-store and online sales with advanced retail IT solutions. Improve inventory visibility, demand forecasting, and customer loyalty with scalable digital platforms."
                />
                <link rel="canonical" href="https://go-te.co/industries/retail" />
            </Helmet>
            <main>
            <Heading title={title} description={description} maxWidth={700} />

            <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                <div>
                    <h3>{t('retail.blackBlocksTitle')}</h3>
                    <p>{t('retail.blackBlocksText')}</p>
                    <p>{t('retail.blackBlocksText2')}</p>
                </div>
                <div className={classes.blocks}>
                    {blackBlocks.map(({ text, icon }) => (<BlackCardWithIcon key={icon} iconName={icon} text={text} />))}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                <div>
                    <h2>{t('retail.challengesBlocksTitle')}</h2>
                </div>
                <div>
                    {challengesBlocks.map(({ icon, text, title }) => <GrayCardBlueIcon iconName={icon} title={title} text={text} key={title} />)}
                </div>
            </section>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('retail.solutionsBlocksTitle')}</h2>
                </div>
                <div>
                    {solutionsBlocks.map(({ image, title, text }) => <div className={classes.block} key={title}>
                        <img alt={title} src={require(`./media/${image}`)} />
                        <div className={classes.content}>
                            <h5>{title}</h5>
                            <p>{text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('retail.benefitBlocksTitle')}</h2>
                    <p>{t('retail.benefitBlocksText')}</p>
                </div>
                <div>
                    {benefitBlocks.map(({ title, text }) => <BlueGradientBlock title={title} text={text} key={title} />)}
                </div>
            </section>

            <section className={"section--dark-gray " + classes['stories']}>
                <h2>{t('retail.storiesTitle')}</h2>
                <div className={classes.blocks}>
                    {stories.map(({ title, text }) => <GrayCardWithVerticalDivider title={title} text={text} key={title} />)}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                <div className={classes.content}>
                    <div className={classes['text-block']}>
                        <h2>{t('retail.useCase')}</h2>
                        <div className={classes.text}>
                            <img src={eRoadImg} alt="Horeca use case" />
                            <p>{useCaseText}</p>
                        </div>
                    </div>
                    <div className={classes.actions}>
                        <span>{t('retail.useCaseText')}</span>
                        <Link className={classes.link} smooth={true} to={'contact'}>
                            {t('retail.useCaseButton')}
                        </Link>
                    </div>
                </div>
                <img className={classes.img} src={eRoadImg} alt="Horeca system" />
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard
                    title={t('retail.formCard.title')}
                    message={t('retail.formCard.message')}
                    buttonText={t('retail.formCard.buttonText')}
                    labels={t('retail.formCard.labels', {returnObjects: true})}
                    top={3} id='contact' />
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('retail.Faq.title')} questions={questions} />
            </section>
        </main>
        </>
    );
};

export default Retail;